import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { JoinPipe, SrPunctuationPipe } from '@woolworthsnz/styleguide';
import { CurrencyPipe } from '@angular/common';

export enum PackageUnit {
	EACH = 'ea',
	TRAY = 'tray',
}

@Component({
	selector: 'product-price-single-unit-average',
	template: `
		<p
			id="product-{{ uniqueId }}-price-single-unit-average"
			class="price-single-unit-text"
			[attr.aria-label]="[price | currency, priceLabel] | join: ' ' | srPunctuation"
		>
			{{ price | currency }} {{ priceLabel }}
		</p>
	`,
	styleUrls: ['./price-single-unit-average.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CurrencyPipe, JoinPipe, SrPunctuationPipe],
})
export class PriceSingleUnitAverageComponent {
	private _packageType = '';
	get isMeatDepartment(): boolean {
		return !!this.departmentName?.match(/meat/i);
	}

	get price(): number | null {
		return this.supportsEachAndKgPricing && this.singleUnitPrice ? this.singleUnitPrice : null;
	}

	get priceLabel(): string | null {
		return this.supportsEachAndKgPricing && this.singleUnitPrice
			? `/ ${this.getUnit(this.packageType)} (approx)`
			: null;
	}

	@Input() singleUnitPrice: number;
	@Input() uniqueId: number;
	@Input() supportsEachAndKgPricing: boolean;
	@Input() departmentName?: string;
	@Input()
	get packageType(): string {
		return this._packageType;
	}
	set packageType(value: string) {
		// we are showing package type only for meat department at the moment
		this._packageType = value && this.isMeatDepartment ? `${value}` : '';
	}

	private getUnit(type: string): PackageUnit {
		return type.toLowerCase() === PackageUnit.TRAY ? PackageUnit.TRAY : PackageUnit.EACH;
	}
}
